import React from 'react';
import PropTypes from 'prop-types';

import {Typography, Box, Stack} from 'views/components';

import {Translate} from 'views/module';

import moment from 'moment-timezone';

const EventHoverDetails = (props) => {
  const {event, styles, isHovered} = props;

  if (!isHovered) return null;

  const startTimeMoment = moment.tz(event.eventData.startTime, event.eventData.timezone);
  const endTimeMoment = moment.tz(event.eventData.endTime, event.eventData.timezone);

  const startTime = startTimeMoment.format('hh:mmA');
  const endTime = endTimeMoment.format('hh:mmA z');

  const dayOfWeek = startTimeMoment.day();

  const showOnLeft = dayOfWeek >= 5;

  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: 0,
        ...(
          showOnLeft ?
            {
              right: '100%',
              marginRight: '10px',
              borderRight: `3px solid ${styles.borderColor}`,
            } :
            {
              left: '100%',
              marginLeft: '10px',
              borderLeft: `3px solid ${styles.borderColor}`,
            }
        ),
        zIndex: 1000,
        width: 220,
        padding: 1,
        borderRadius: 1,
        backgroundColor: 'white',
        boxShadow: 3,
      }}
    >
      <Typography variant="subtitle2" sx={{fontWeight: 'bold', color: styles.borderColor, mb: 1}}>
        {event.info.title}
      </Typography>
      <Stack direction='row' spacing={1}>
        <Typography variant="caption" sx={{fontWeight: 'bold'}}>
          <Translate expression='caregiver.CaregiverCalendar.Calendar.Details.Time' />
        </Typography>
        <Typography variant="caption">
          {startTime}-{endTime}
        </Typography>
      </Stack>
      <Stack direction='row' spacing={1}>
        <Typography variant="caption" sx={{fontWeight: 'bold'}}>
          <Translate expression='caregiver.CaregiverCalendar.Calendar.Details.Status' />
        </Typography>
        <Typography variant="caption" sx={{color: styles.borderColor, fontWeight: 'medium'}}>
          {styles.label}
        </Typography>
      </Stack>
    </Box>
  );
};

EventHoverDetails.propTypes = {
  event: PropTypes.object.isRequired,
  styles: PropTypes.object.isRequired,
  isHovered: PropTypes.bool.isRequired,
};

export default EventHoverDetails;
